import { createFeatureSelector } from '@ngrx/store';
import { SERVICE_REQUEST_PAYMENT_INPUT, ServiceRequestPaymentInputState } from './service-request-payment-input.state';

export const getDataServiceRequestPaymentInput =
  createFeatureSelector<ServiceRequestPaymentInputState>(SERVICE_REQUEST_PAYMENT_INPUT);
